export default function ProfileIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5C9.79 5 8 6.79 8 9C8 11.21 9.79 13 12 13C14.21 13 16 11.21 16 9C16 6.79 14.21 5 12 5ZM12 11C10.9 11 10 10.1 10 9C10 7.9 10.9 7 12 7C13.1 7 14 7.9 14 9C14 10.1 13.1 11 12 11ZM12 14C9 14 5 16.34 5 19L7 19.01C7 19.01 13.0948 19.0039 17 19C17.781 19 19 19 19 19C19 16.34 15 14 12 14ZM7 19.01C7.2 18.29 9 16 12 16C15 16 16.8 18.29 17 19C13.0948 19.0039 7 19.01 7 19.01Z"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
